export const BaseUrl="https://smartone.pythonanywhere.com/api/user"
export const Url='https://smartone.pythonanywhere.com/api/user'

